/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Archive } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	messagesHistory: {},
};

const setMessagesHistory: ReduxReducer<State, State["messagesHistory"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);
		if (!Number.isNaN(numericId)) {
			state.messagesHistory[numericId] = data;
		}
	}

	// state.messagesHistory = action.payload;
};

const archivesMessagesHistoryData = createSlice({
	name: Archive.ConstantOrderSlice.MESSAGES_HISTORY_DATA,
	initialState,
	reducers: {
		setMessagesHistory,
	},
});

export const archivesMessagesHistoryDataAction =
	archivesMessagesHistoryData.actions;
export const archivesMessagesHistoryDataReducer =
	archivesMessagesHistoryData.reducer;
export type archivesMessagesHistoryDataState = State;

export default archivesMessagesHistoryData;
